export default {
    query: 'query',
    headers: 'headers',
    body: 'body',
    params: 'params',
};
